import { isSuperAdmin, validarPermissoes } from "../../utils/PermissaoUtils";
import BotaoPadrao from "../BotaoPadrao/BotaoPadrao";
import { IoAddOutline } from 'react-icons/io5';
import './CabecalhoPadrao.css';
import { PiExportBold } from "react-icons/pi";

const CabecalhoPadrao = ({
    titulo,
    textAdd,
    permissao,
    onClick,
    gerarCsv,
    gerarCsvAdicional,
    textoCsv,
    textoCsvAdicional,
    textoTooltip = '',
    textoTooltipAdicional = '',
}) => {

    const hasPermissao = validarPermissoes(permissao);

    return (
      <div className="cabecalho-padrao">
        <h1 className="cabecalho-padrao-titulo">{titulo}</h1>

        <div className="container-botoes">
          {gerarCsv && isSuperAdmin() && (
            <BotaoPadrao
              aoClicar={gerarCsv}
              icone={<PiExportBold />}
              classeCustom="botao-menor"
              apenasIcone={true}
              texto={textoCsv}
              textoTooltip={textoTooltip}
            />
          )}

          {gerarCsvAdicional && isSuperAdmin() && (
            <BotaoPadrao
              aoClicar={gerarCsvAdicional}
              icone={<PiExportBold />}
              classeCustom="botao-menor"
              apenasIcone={true}
              texto={textoCsvAdicional}
              textoTooltip={textoTooltipAdicional}
            />
          )}

          {hasPermissao && (
            <BotaoPadrao
              cancelar={true}
              aoClicar={onClick}
              icone={<IoAddOutline />}
              texto={`Adicionar ${textAdd ?? titulo.replace(/s$/i, '')}`.toUpperCase()}
              classeCustom="botao-menor"
            />
          )}
        </div>
      </div>
    );
}
 
export default CabecalhoPadrao;